import { ClipboardTextIcon, PhoneIcon, type Icon } from '@phosphor-icons/react';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

import { CallsDashboard } from '@components/dashboard/calls-dashboard';
import { EvalsDashboard } from '@components/dashboard/evals-dashboard';
import { callsListQueryOptions } from '@services/calls/queryOptions';

const dashboardSearchSchema = z.object({
  view: z.enum(['calls', 'evals']).default('calls'),
});

type DashboardTabView = z.infer<typeof dashboardSearchSchema>['view'];

type DashboardTabConfig = {
  description: string;
  icon: Icon;
  title: string;
};

const dashboardTabs: Record<DashboardTabView, DashboardTabConfig> = {
  calls: {
    description: 'Numbers to call, synced from the Google Sheet, with status.',
    icon: PhoneIcon,
    title: 'Calls',
  },
  evals: {
    description: 'Placeholder workspace for reviewing evaluation runs.',
    icon: ClipboardTextIcon,
    title: 'Evals',
  },
};

export const Route = createFileRoute('/_dashboard/')({
  component: DashboardIndex,
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(callsListQueryOptions()),
  validateSearch: search => dashboardSearchSchema.parse(search),
});

function DashboardIndex() {
  const { view } = Route.useSearch();
  const tab = dashboardTabs[view];

  if (view === 'evals') {
    return (
      <EvalsDashboard
        description={tab.description}
        icon={tab.icon}
        title={tab.title}
      />
    );
  }

  return (
    <CallsDashboard
      description={tab.description}
      icon={tab.icon}
      title={tab.title}
    />
  );
}
